import bannerImg from "../assets/images/contact-head-banner.png"
import ContactUs from "../components/ContactUs"
import HeadBanner from "../components/HeadBanner";
import HorizontalBar from "../components/HorizontalBar";


const ContactPage = () => {
    return(
        <>
            <HeadBanner imageUrl={bannerImg} />
            <ContactUs />
            <HorizontalBar />
        </>
    )
}

export default ContactPage;